import { Injectable } from '@angular/core';
import moment from 'moment';
import {
  EmployeeCapabilityResponse,
  EmployeeManagerSettingsResponse,
  EmployeeMaximumWorkHoursResponse,
  EmployeeOneTimePreferredTimeOffResponse,
  EmployeeRankResponse,
  EmployeeSummaryResponse,
  EmployeeWeeklyAvailabilityResponse,
  EmployeeWeeklyPreferredTimeOffResponse
} from '../../../interfaces/response/EmployeeResponse';
import { CapabilityType } from '../../../classes/enums/CapabilityType';
import { EmployeeRankEnum } from '../../../classes/enums/EmployeeRankEnum';

@Injectable({
  providedIn: 'root',
})
export class TestEmployeeDataService {

  /** Employees test data. */
  employees: EmployeeSummaryResponse[] = [
    {
      employeeId: 'AAA',
      positionId: 'DFSAAA',
      name: 'John Smith',
      role: 'Senior Sales Advisor',
      contractHours: 'PT40H',
      availableFrom: moment().startOf('isoWeek').add(1, 'week').format('YYYY-MM-DD'),
      deletedFrom: null
    },
    {
      employeeId: 'BBB',
      positionId: 'DFSBBB',
      name: 'Sarah Johnson',
      role: 'Sales Advisor',
      contractHours: 'PT35H',
      availableFrom: null,
      deletedFrom: null
    },
    {
      employeeId: 'CCC',
      positionId: 'DFSCCC',
      name: 'James Ross',
      role: 'Sales Advisor',
      contractHours: 'PT30H',
      availableFrom: null,
      deletedFrom: null
    },
    {
      employeeId: 'DDD',
      positionId: 'DFSDDD',
      name: 'Kevin Morris',
      role: 'General Manager',
      contractHours: 'PT20H',
      availableFrom: moment().startOf('isoWeek').add(2, 'weeks').format('YYYY-MM-DD'),
      deletedFrom: null
    },
    {
      employeeId: 'EEE',
      positionId: 'DFSEEE',
      name: 'Rachel Smithers',
      role: 'Senior Sales Advisor',
      contractHours: 'PT26H',
      availableFrom: null,
      deletedFrom: null
    },
    {
      employeeId: 'FFF',
      positionId: 'DFSFFF',
      name: 'Waseemuddin Syed Shah',
      role: 'Sales Advisor',
      contractHours: 'PT30H',
      availableFrom: null,
      deletedFrom: moment().startOf('isoWeek').add(1, 'week').format('YYYY-MM-DD')
    }
  ];

  /** Capabilities test data. */
  capabilities: EmployeeCapabilityResponse[] = [{ date: '2020-01-06', capabilities: [CapabilityType.BANKING] }];

  /** Maximum working hours test data. */
  maximumWorkingHours: EmployeeMaximumWorkHoursResponse[] = [{ date: '2020-01-06', duration: 'PT42H' }];

  /** Availabilities test data. */
  availabilities: EmployeeWeeklyAvailabilityResponse[] = [{
    date: '2020-01-06',
    monday: { startTime: '09:00:00', endTime: '17:00:00' },
    tuesday: { startTime: '09:00:00', endTime: '17:00:00' },
    wednesday: { startTime: '09:00:00', endTime: '20:00:00' },
    thursday: { startTime: '09:00:00', endTime: '20:00:00' },
    friday: null,
    saturday: { startTime: '09:00:00', endTime: '20:00:00' },
    sunday: { startTime: '09:00:00', endTime: '12:00:00' }
  }];

  /** Preferred times off test data. */
  preferredTimesOff: EmployeeWeeklyPreferredTimeOffResponse[] = [{
    date: '2020-01-06',
    monday: { startTime: '17:00:00', endTime: '20:00:00', reason: '-' },
    tuesday: { startTime: '09:00:00', endTime: '17:00:00', reason: 'Reoccurring medical appointment' },
    wednesday: null,
    thursday: null,
    friday: null,
    saturday: null,
    sunday: null
  }];

  /** Temporary preferred times off test data. */
  temporaryPreferredTimesOff: EmployeeOneTimePreferredTimeOffResponse[] = [];

  /** Employee roles test data. */
  employeeRanks: EmployeeRankResponse[] = [{ date: '2020-01-06', rank: EmployeeRankEnum.Rank_1 }];

  /** Manager settings response test data. */
  managerSettings: EmployeeManagerSettingsResponse[] = [{ date: '2020-01-06', canDoSales: false }];

  /**
   * Get employee contract hours by the given employee.
   * @param employee a specific employee object.
   */
  getContractHours(employee) {
    return [{ date: '2020-01-06', duration: employee.contractHours }];
  }
}
